import type { InputMode } from '@brighterly/lib-core-types/ui/inputs/types'
import type { ChangeEvent } from '@brighterly/lib-core-types/ui/inputs/interfaces'

import { getMode } from '@shared/lib/mode'

import { useTutorApplicationStore } from '../store'

interface FullNameReturn {
  mode: ComputedRef<InputMode>
  setFullName: (event: ChangeEvent) => void
}

export const useFullName = (): FullNameReturn => {
  const tutorApplicationStore = useTutorApplicationStore()

  const mode = computed(() => getMode(tutorApplicationStore.getShowErrors && !tutorApplicationStore.fullName))

  const setFullName = (event: ChangeEvent) => {
    tutorApplicationStore.setFullName(event.value)
  }

  return {
    mode,
    setFullName,
  }
}